import React from "react"
import * as S from "./custom-input.styles"
import { useFormContext, Controller } from "react-hook-form"
import { getRHFErrorMessage } from "../../utils"
import { InputAdornment } from "@mui/material"

const CustomInput = ({
  title,
  name,
  validations,
  label,
  className,
  type = "text",
  variant = "outlined",
  multiline,
  defaultValue = "",
  size = "small",
  IconComponent,
  ...otherProps
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext()

  const error = getRHFErrorMessage(errors, name, validations)

  return (
    <S.InputContainer className={className}>
      {title && <S.Title>{title}</S.Title>}
      <Controller
        rules={validations}
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <S.CustomInput
            error={!!error}
            required={!!validations?.required}
            variant={variant}
            label={label}
            helperText={error}
            type={type}
            multiline={multiline}
            size={size}
            InputProps={
              IconComponent
                ? {
                    endAdornment: (
                      <InputAdornment position="end">
                        {IconComponent}
                      </InputAdornment>
                    ),
                  }
                : null
            }
            {...otherProps}
            {...field}
          />
        )}
      />
    </S.InputContainer>
  )
}

export default CustomInput
